import { apiClient } from './client';
import { EmployeeDocument } from '../types/documents';

const CATEGORY_LABELS: Record<string, string> = { identity: 'Identity', education: 'Education & Qualifications', employment: 'Employment', payroll: 'Payroll/Statutory', other: 'Other' };
export { CATEGORY_LABELS };

export const employeeDocumentApi = {
  listMine: () => apiClient.get<{ data: EmployeeDocument[] }>('/api/employees/me/documents'),
  uploadMine: (input: { fileDataUri: string; originalFilename: string; documentType: string; category: string }) =>
    apiClient.post<{ data: { id: number } }>('/api/employees/me/documents', input),
  downloadMineUrl: (documentId: number) => `/api/employees/me/documents/${documentId}/download`,
  deleteMine: (documentId: number) => apiClient.delete<{ data: { id: number; deleted: boolean } }>(`/api/employees/me/documents/${documentId}`),

  listForEmployee: (employeeId: number) => apiClient.get<{ data: EmployeeDocument[] }>(`/api/employees/${employeeId}/documents`),
  uploadForEmployee: (employeeId: number, input: { fileDataUri: string; originalFilename: string; documentType: string; category: string }) =>
    apiClient.post<{ data: { id: number } }>(`/api/employees/${employeeId}/documents`, input),
  downloadForEmployeeUrl: (employeeId: number, documentId: number) => `/api/employees/${employeeId}/documents/${documentId}/download`,
  deleteForEmployee: (employeeId: number, documentId: number) => apiClient.delete<{ data: { id: number; deleted: boolean } }>(`/api/employees/${employeeId}/documents/${documentId}`),
};
